import { OrderLineMessage, OrderLineMessageType } from '../../../../core/model';
import { AlertType } from '../../../../core/model/misc.model';
import { Occ } from '../../../../core/occ/occ-models/occ.models';

export function convertOrderLineMessages(source: Occ.Message[]): OrderLineMessage[] {
  return source
    ? source.map((message) => {
        const type = message.type as OrderLineMessageType;
        return {
          ...message,
          updateable:
            [
              OrderLineMessageType.CODE_ORDERLINE_DELIVERY_QUANTITY,
              OrderLineMessageType.CODE_ORDERLINE_MINIMUM_PURCHASE_QUANTITY,
            ].includes(type) &&
            message.quantity > 0 &&
            Boolean(message.unit),
          type,
          tag: message.tag as AlertType,
          unitCode: message.unit,
        };
      })
    : [];
}
